import React, { useCallback, memo } from 'react';
import { XIcon, CheckCircleIcon, InfoIcon, StarIcon, ShareIcon, VideoIcon, HeartIcon } from 'lucide-react';
interface UpdateItemProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}
const UpdateItem = memo(({
  icon,
  title,
  description
}: UpdateItemProps) => <div className="flex" data-id="element-2616">
    {icon}
    <div data-id="element-2617">
      <p className="font-medium text-slate-800" data-id="element-2618">{title}</p>
      <p className="text-sm text-slate-600" data-id="element-2619">{description}</p>
    </div>
  </div>);
interface UpdatesDialogProps {
  onClose: () => void;
}
export const UpdatesDialog = memo(({
  onClose
}: UpdatesDialogProps) => {
  const handleShare = useCallback(async () => {
    try {
      const shareData = {
        title: 'تطبيق الإرشاد الزوجي الإسلامي',
        text: 'تطبيق شامل للإرشاد الزوجي من منظور إسلامي - تحديثات جديدة متاحة الآن!',
        url: window.location.href
      };
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(`${shareData.title}\n${shareData.text}\n${shareData.url}`);
        alert('تم نسخ رابط التطبيق إلى الحافظة');
      }
    } catch (error) {
      console.error('Error sharing:', error);
    }
  }, []);
  return <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-50 p-4" data-id="element-2620">
      <div className="bg-white rounded-xl shadow-xl max-w-lg w-full max-h-[80vh] overflow-hidden flex flex-col animate-fadeIn" data-id="element-2621">
        <div className="p-5 bg-gradient-to-r from-amber-50 to-amber-100 border-b border-amber-100 flex justify-between items-center" data-id="element-2622">
          <div className="flex items-center" data-id="element-2623">
            <div className="p-2 bg-amber-200 rounded-full mr-3" data-id="element-2624">
              <InfoIcon className="h-6 w-6 text-amber-700" data-id="element-2625" />
            </div>
            <h2 className="text-xl font-bold text-amber-900" data-id="element-2626">
              التحديثات الأخيرة
            </h2>
          </div>
          <div className="flex items-center" data-id="element-2627">
            <button onClick={handleShare} className="p-2 rounded-full hover:bg-amber-200 transition-colors mr-2" aria-label="مشاركة التطبيق" data-id="element-2628">
              <ShareIcon className="h-5 w-5 text-amber-700" data-id="element-2629" />
            </button>
            <button onClick={onClose} className="p-2 rounded-full hover:bg-amber-200 transition-colors" aria-label="إغلاق" data-id="element-2630">
              <XIcon className="h-5 w-5 text-amber-700" data-id="element-2631" />
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto p-6" data-id="element-2632">
          <div className="mb-6" data-id="element-2633">
            <div className="flex items-center mb-4" data-id="element-2634">
              <div className="p-1.5 bg-sky-100 rounded-full mr-3" data-id="element-2635">
                <StarIcon className="h-5 w-5 text-sky-600" data-id="element-2636" />
              </div>
              <h3 className="text-lg font-bold text-sky-800" data-id="element-2637">الإصدار 1.1</h3>
            </div>
            <div className="space-y-4 text-slate-700" data-id="element-2638">
              <UpdateItem icon={<CheckCircleIcon className="h-5 w-5 text-emerald-500 flex-shrink-0 mt-1 ml-3" data-id="element-2640" />} title="إضافة قسم 'بطاقات معرفية'" description="مجموعة من البطاقات المعرفية حول حقوق الزوجين في الإسلام" data-id="element-2639" />
              <div className="flex" data-id="element-2641">
                <CheckCircleIcon className="h-5 w-5 text-emerald-500 flex-shrink-0 mt-1 ml-3" data-id="element-2642" />
                <div data-id="element-2643">
                  <p className="font-medium text-slate-800" data-id="element-2644">
                    إضافة قسم "مرحلة الخطوبة"
                  </p>
                  <p className="text-sm text-slate-600" data-id="element-2645">
                    دليل شامل للخاطبين حول آداب وأحكام وضوابط الخطوبة في الإسلام
                  </p>
                </div>
              </div>
              <div className="flex" data-id="element-2646">
                <CheckCircleIcon className="h-5 w-5 text-emerald-500 flex-shrink-0 mt-1 ml-3" data-id="element-2647" />
                <div data-id="element-2648">
                  <p className="font-medium text-slate-800" data-id="element-2649">
                    إضافة قسم "الاستعداد للحياة الزوجية"
                  </p>
                  <p className="text-sm text-slate-600" data-id="element-2650">
                    إرشادات وتوجيهات للمقبلين على الزواج للاستعداد النفسي
                    والاجتماعي والمادي للحياة الزوجية
                  </p>
                </div>
              </div>
              <div className="flex" data-id="element-2651">
                <VideoIcon className="h-5 w-5 text-emerald-500 flex-shrink-0 mt-1 ml-3" data-id="element-2652" />
                <div data-id="element-2653">
                  <p className="font-medium text-slate-800" data-id="element-2654">
                    إضافة مكتبة الفيديوهات التوعوية
                  </p>
                  <p className="text-sm text-slate-600" data-id="element-2655">
                    مجموعة من الفيديوهات التعليمية والإرشادية حول مختلف جوانب
                    الحياة الزوجية من منظور إسلامي
                  </p>
                </div>
              </div>
              <div className="flex" data-id="element-2656">
                <div className="h-5 w-5 text-emerald-500 flex-shrink-0 mt-1 ml-3" data-id="element-2657" />
                <div data-id="element-2658">
                  <p className="font-medium text-slate-800" data-id="element-2659">
                    إضافة مكتبة الأدوات الزوجية
                  </p>
                  <p className="text-sm text-slate-600" data-id="element-2660">
                    مجموعة من الأدوات العملية لتحسين التواصل وحل المشكلات وتعزيز
                    العلاقة بين الزوجين
                  </p>
                </div>
              </div>
              <div className="flex" data-id="element-2661">
                <HeartIcon className="h-5 w-5 text-emerald-500 flex-shrink-0 mt-1 ml-3" data-id="element-2662" />
                <div data-id="element-2663">
                  <p className="font-medium text-slate-800" data-id="element-2664">
                    إضافة قسم "حقوق الأبناء"
                  </p>
                  <p className="text-sm text-slate-600" data-id="element-2665">
                    دليل شامل حول حقوق الأبناء في الإسلام وكيفية تربيتهم تربية
                    إسلامية صحيحة
                  </p>
                </div>
              </div>
              <div className="flex" data-id="element-2666">
                <CheckCircleIcon className="h-5 w-5 text-emerald-500 flex-shrink-0 mt-1 ml-3" data-id="element-2667" />
                <div data-id="element-2668">
                  <p className="font-medium text-slate-800" data-id="element-2669">
                    إضافة زر المشاركة
                  </p>
                  <p className="text-sm text-slate-600" data-id="element-2670">
                    الآن يمكنك مشاركة التطبيق بسهولة مع العائلة والأصدقاء
                  </p>
                </div>
              </div>
              <div className="flex" data-id="element-2671">
                <CheckCircleIcon className="h-5 w-5 text-emerald-500 flex-shrink-0 mt-1 ml-3" data-id="element-2672" />
                <div data-id="element-2673">
                  <p className="font-medium text-slate-800" data-id="element-2674">
                    تحسينات في الواجهة والتصميم
                  </p>
                  <p className="text-sm text-slate-600" data-id="element-2675">
                    تحسينات متعددة في واجهة المستخدم لتسهيل التصفح والاستخدام
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-4" data-id="element-2676">
            <div className="flex items-center mb-4" data-id="element-2677">
              <div className="p-1.5 bg-purple-100 rounded-full mr-3" data-id="element-2678">
                <InfoIcon className="h-5 w-5 text-purple-600" data-id="element-2679" />
              </div>
              <h3 className="text-lg font-bold text-purple-800" data-id="element-2680">قادم قريباً</h3>
            </div>
            <ul className="space-y-3 text-slate-700" data-id="element-2681">
              <li className="flex items-start" data-id="element-2682">
                <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-purple-500 mt-2" data-id="element-2683"></span>
                <span data-id="element-2684">قسم خاص بالأسئلة الشائعة حول الحياة الزوجية</span>
              </li>
              <li className="flex items-start" data-id="element-2685">
                <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-purple-500 mt-2" data-id="element-2686"></span>
                <span data-id="element-2687">مقالات توعوية حول التربية الإسلامية للأبناء</span>
              </li>
              <li className="flex items-start" data-id="element-2688">
                <span className="ml-2 flex-shrink-0 h-2 w-2 rounded-full bg-purple-500 mt-2" data-id="element-2689"></span>
                <span data-id="element-2690">أداة تفاعلية لحل المشكلات الزوجية الشائعة</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="p-4 border-t border-slate-100 bg-slate-50 flex justify-end" data-id="element-2691">
          <button onClick={onClose} className="px-5 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded-md transition-colors font-medium" data-id="element-2692">
            حسناً، فهمت
          </button>
        </div>
      </div>
    </div>;
});
UpdatesDialog.displayName = 'UpdatesDialog';